module.exports = __webpack_public_path__ + "static/media/nissan-off-app-provider-icon.e1e4d089.svg";